const bulkPromotionComponent = () => import('@/views/bulkPromotion/bulkPromotion.vue')
const bulkPromotionCreate = () => import('@/views/bulkPromotion/createBulkPromotion.vue')
const bulkPromotionUpdate = () => import('@/views/bulkPromotion/updateBulkPromotion.vue')

export default {
    path: 'bulkPromotion',
    meta: { label: 'Bulk Promotion' },
    component: {
        render(c) { return c('router-view') }
    },
    children: [
        {
            path: '',
            meta: {
                requiresAuth: true,
            },
            component:bulkPromotionComponent
        },
        {
            path: '/create',
            name:"create-promo",
            meta: {
                requiresAuth: true,
            },
            component:bulkPromotionCreate
        },
        {
            path: '/createbulkpromo/:id',
            name:"bulkpromo",
            meta: {
                requiresAuth: true,
            },
            component:bulkPromotionUpdate
        },
    ]
}